// extracted by mini-css-extract-plugin
module.exports = {"container":"ContactContainer_container__2snyJ","social":"ContactContainer_social__2hYFi","iconsContainer":"ContactContainer_iconsContainer__1oO56"};